module.exports = __webpack_public_path__ + "img/编组 27@2x.76fd1589.png";